// permissions.ts
import { AuthorityName, isAdmin, isEditor, isGlobalViewer, isViewer } from './roles';

export const canEditRobAndDeliveries = (role?: AuthorityName) => isAdmin(role) || isEditor(role);

export const canViewRobAndDeliveries = (role?: AuthorityName) =>
  isAdmin(role) || isGlobalViewer(role) || isEditor(role) || isViewer(role);

export const canEditReferenceData = (role?: AuthorityName) => isAdmin(role); // Products, Categories, Types, etc.

export const canViewReferenceData = (role?: AuthorityName) =>
  isAdmin(role) || isGlobalViewer(role) || isEditor(role) || isViewer(role); // Products, Categories, Types, etc.

export const canEditLubricationCharts = (role?: AuthorityName) => isAdmin(role) || isEditor(role);

export const canViewLubricationCharts = (role?: AuthorityName) =>
  isAdmin(role) || isGlobalViewer(role) || isEditor(role) || isViewer(role);

export const canCreateTypeInProducts = (role?: AuthorityName) => isAdmin(role) || isEditor(role);

export const canEditTypeInProducts = (role?: AuthorityName) => isAdmin(role);

export const canViewTypeInProducts = (role?: AuthorityName) =>
  isAdmin(role) || isGlobalViewer(role) || isViewer(role);

export const canEditManagementPeriods = (role?: AuthorityName) => isAdmin(role);

export const canViewManagementPeriods = (role?: AuthorityName) =>
  isAdmin(role) || isEditor(role) || isGlobalViewer(role) || isViewer(role);

export const canEditPricelists = (role?: AuthorityName) => isAdmin(role);

export const canViewPricelists = (role?: AuthorityName) => isAdmin(role) || isGlobalViewer(role);

// Route access: role can either edit or view the module
export const canAccessRobAndDeliveries = (role?: AuthorityName) =>
  canEditRobAndDeliveries(role) || canViewRobAndDeliveries(role);

export const canAccessLubricationCharts = (role?: AuthorityName) =>
  canEditLubricationCharts(role) || canViewLubricationCharts(role);

export const canAccessReferenceData = (role?: AuthorityName) =>
  canEditReferenceData(role) || canViewReferenceData(role);

export const canAccessManagementPeriods = (role?: AuthorityName) =>
  canEditManagementPeriods(role) || canViewManagementPeriods(role);

export const canAccessPricelists = (role?: AuthorityName) =>
  canEditPricelists(role) || canViewPricelists(role);

export const canAccessTypeInProducts = (role?: AuthorityName) =>
  canCreateTypeInProducts(role) || canEditTypeInProducts(role) || canViewTypeInProducts(role);

// Companies & Extra Costs: restricted to Admin and Global Viewer
export const canAccessCompanies = (role?: AuthorityName) => isAdmin(role) || isGlobalViewer(role);

export const canAccessExtraCosts = (role?: AuthorityName) => isAdmin(role) || isGlobalViewer(role);

export const canAccessReports = (role?: AuthorityName) =>
  isAdmin(role) || isGlobalViewer(role) || isEditor(role);

// Single source of truth for navigation visibility (must mirror the route guards in App.tsx)
const ROUTE_PERMISSIONS: Record<string, (_role?: AuthorityName) => boolean> = {
  '/deliveries/add': canEditRobAndDeliveries,
  '/rob/add': canEditRobAndDeliveries,
  '/reports': canAccessReports,
  '/deliveries': canAccessRobAndDeliveries,
  '/rob': canAccessRobAndDeliveries,
  '/lubrication-charts': canAccessLubricationCharts,
  '/lubricants/products': canAccessReferenceData,
  '/lubricants/categories': canAccessReferenceData,
  '/lubricants/types': canAccessReferenceData,
  '/lubricants/groups': canAccessReferenceData,
  '/companies/makers': canAccessCompanies,
  '/companies/suppliers': canAccessCompanies,
  '/companies/customer': canAccessCompanies,
  '/price-list': canAccessPricelists,
  '/extra-costs': canAccessExtraCosts,
  '/management-periods': canAccessManagementPeriods,
  '/type-in-lubricants': canAccessTypeInProducts,
};

export const canAccessRoute = (route: string, role?: AuthorityName) =>
  ROUTE_PERMISSIONS[route]?.(role) ?? false;
